import { calculateHoursForImpressions } from "../../../../services/utils";

export const formatMoney = (amount, currency = "ARS") => {
  const value = Number(amount);
  if (Number.isNaN(value)) return "—";
  const cur = currency || "ARS";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: cur,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (e) {
    return `${cur} ${value.toFixed(2)}`.trim();
  }
};

export const getSizeLabel = (sizeType, t) => {
  const map = { small: t("Small"), medium: t("Medium"), big: t("Big"), giant: t("Giant") };
  return map[sizeType] || sizeType || "—";
};

export const getSizeText = (display, t) => {
  const label = getSizeLabel(display.size_type, t);
  if (display.size_width && display.size_height) {
    return `${label}, ${display.size_width}m x ${display.size_height}m`;
  }
  return label;
};

export const getAdFormats = (formatSettings, t) => {
  if (!formatSettings) return "—";
  const labels = { image: t("Image"), video: t("Video"), html: t("HTML") };
  const arr = Object.keys(formatSettings)
    .filter((k) => formatSettings[k])
    .map((k) => labels[k] || k.charAt(0).toUpperCase() + k.slice(1));
  return arr.length ? arr.join(" - ") : "—";
};

export const getRotationLabel = (rotation, t) => {
  if (rotation === 90) return `90° ${t("to the right")}`;
  if (rotation === -90) return `90° ${t("to the left")}`;
  if (rotation === 0 || rotation == null) return t("Normal");
  return `${rotation}°`;
};

export const getApproxSpots = (display) =>
  Math.round((display.shows_per_hour || 0) * (calculateHoursForImpressions(display) / 60));

export const getRestrictions = (display, t) =>
  display.constraints && String(display.constraints).trim()
    ? display.constraints
    : t("No restrictions");

export const getCostPerDay = (display) =>
  display.base_price_per_day != null ? display.base_price_per_day : display.price_per_day;

export const getAudienceValues = (display) => {
  const a = display.audience || {};
  return { day: a.day || 0, week: a.week || 0, month: a.month || 0 };
};
